import React, { Component } from 'react';
import { getHyphenDDMMYYYYHHMM, getHyphenDDMMYYYYHHMMSS, getHyphenYYYYMMDDHHMM, getHyphenDDMMYYYY } from '../common/utils';
var moment = require('moment');

class RFQView extends Component {
  constructor(props) {
    super(props);

    this.thStyle = {
      border: "1px solid #ddd",
      padding: "10px",
      fontWeight: "600",
      backgroundColor: "#0073aa",
      color: "white",
      textAlign: "left",
    };

    this.tdStyle = {
      //   border: "1px solid #ddd",
      border: "1px solid #eeeeee",
      padding: "10px",
      backgroundColor: "#fff",
      verticalAlign: "top",
      // whiteSpace: "nowrap"  
    };
    this.tdStyle1 = {
      //   border: "1px solid #ddd",
      border: "1px solid #eeeeee",
      padding: "10px",
      backgroundColor: "#fff",
      verticalAlign: "top",
      whiteSpace: "nowrap"
    };

    this.tdStyleGray = {
      //   border: "1px solid #ddd",
      border: "1px solid #eeeeee",
      padding: "10px",
      backgroundColor: "#f8f9fa",
      verticalAlign: "top",
      fontWeight: "600",
      color: "#666",
    };
  }
  onBackToEdit = () => {
    const { onBackToEdit } = this.props;
    if (typeof onBackToEdit === 'function') {
      onBackToEdit(); // calls parent function
    }
  };
  onSubmitRfq = () => {
    const { onSubmitRfq } = this.props;
    if (typeof onSubmitRfq === 'function') {
      onSubmitRfq(); // calls parent function
    }
  };
  formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${d.getFullYear()}`;
  };

  // Helper function to get options label
  getOptionsLabel = (options, value) => {
    for (let e of options) {
      if (e.value == value) return e.label;
    }
  };
  isDealerRowFilled(dealer) {
    return (
      (dealer.dealer_code && dealer.dealer_code.trim() !== "") ||
      (dealer.dealer_name && dealer.dealer_name.trim() !== "") ||
      (dealer.dealer_city && dealer.dealer_city.trim() !== "") ||
      (dealer.dealer_state && dealer.dealer_state.trim() !== "") ||
      (dealer.dealer_pincode && dealer.dealer_pincode.trim() !== "")
    );
  }


  // Helper function to parse vendors_names
  parseVendorNames = (vendorNames) => {
    if (!vendorNames) return [];
    try {
      // If it's already an array, return it
      if (Array.isArray(vendorNames)) return vendorNames;
      // If it's a string, parse it
      if (typeof vendorNames === 'string') {
        return JSON.parse(vendorNames);
      }
      return [];
    } catch (error) {
      console.error('Error parsing vendor names:', error);
      return [];
    }
  };

  // Helper function to parse destinations and extract cities
  parseDestinations = (destinations) => {
    if (!destinations) return "";
    try {
      // If it's already an array, extract cities
      if (Array.isArray(destinations)) {
        return destinations.map(dest => dest.dealer_city).join(", ");
      }
      // If it's a string, parse it first then extract cities
      if (typeof destinations === 'string') {
        const parsedDestinations = JSON.parse(destinations);
        return parsedDestinations.map(dest => dest.dealer_city).join(", ");
      }
      return "";
    } catch (error) {
      console.error('Error parsing destinations:', error);
      return "";
    }
  };

  render() {
    const unitsOptions1 = [
      { value: "others", label: "Others" },
      { value: "truck", label: "Truck(FTL)" },
      { value: "metric_tons", label: "Metric Tonnes(PTL)" },
      { value: "kilogram", label: "Kilogram(Courier)" },
      { value: "box", label: "Box(FTL/PTL)" }
    ]
    const { rfqForm, dealers } = this.props;
    var dealerslist = dealers.filter(function (dealer) {
      return dealer.dealer_code && dealer.dealer_code.trim() !== "";
    });
    console.log(dealerslist,'dealerslist')
    return (
      <div style={{ padding: "0px 20px", fontSize: "14px", color: "#333" }}>
        {this.props.checkforcreateindent ? <div style={{ marginBottom: "24px", fontWeight: "bold" }}>Indent Preview</div>
          : <div style={{ marginBottom: "24px", fontWeight: "bold" }}>Indent Preview - {rfqForm.indent_id}</div>
        }
        <section
          style={{
            border: "0.5px solid #FFFFF",
            padding: "0",
            borderRadius: "8px",
            backgroundColor: "#fff",
            marginBottom: "30px",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th
                  colSpan="6"
                  style={{
                    textAlign: "left",
                    padding: "12px",
                    background: "#e8f4ff",
                    borderBottom: "0.5px solid #FFFFF",
                    fontSize: "15px",
                    fontWeight: "600",
                  }}
                >
                  Basic Information
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td style={this.tdStyleGray}>RFQ Type</td>
                <td style={this.tdStyle}>{(rfqForm && rfqForm.auction_type) || "Spot"}</td>
                <td style={this.tdStyleGray}>Unit</td>
                <td style={this.tdStyle}>

                  {rfqForm.selected_units ||rfqForm.units}
                </td>

                <td style={this.tdStyleGray}>Base Price (₹)</td>
                <td style={this.tdStyle}>{(rfqForm && rfqForm.base_price) || "0"}</td>
              </tr>
              <tr>
                <td style={this.tdStyleGray}>Source</td>
                <td style={this.tdStyle}>
                  {(rfqForm && rfqForm.source) === "others"
                    ? rfqForm.selected_source_type
                    : (rfqForm && rfqForm.source) || ""}
                </td>
                <td style={this.tdStyleGray}>Destination(s)</td>
                <td style={this.tdStyle}>
                  {rfqForm && rfqForm.destination
                    ? this.parseDestinations(rfqForm.destination)
                    : Array.isArray(dealerslist)
                      ? dealerslist.map(d => d.dealer_city).join(", ")
                      : ""}
                </td>

                <td style={this.tdStyleGray}>Pickup Date</td>
                <td style={this.tdStyle}>{this.formatDate(rfqForm && rfqForm.pickup_date)}</td>
              </tr>
              <tr>
                <td style={this.tdStyleGray}>Distance</td>
                <td style={this.tdStyle}>{rfqForm.total_km ? `${rfqForm.total_km} KM` : ''}</td>
                <td style={this.tdStyleGray}>Bid Start Date</td>
                <td style={this.tdStyle}>{rfqForm.bid_start_date ? getHyphenDDMMYYYYHHMM(rfqForm.bid_start_date) : ''}</td>
                <td style={this.tdStyleGray}>Indent Validity</td>
                <td style={this.tdStyle}>
                  {rfqForm && rfqForm.quotation_validity_hours ? `${rfqForm.quotation_validity_hours} Hours` : "HH:MM"}
                </td>
              </tr>
              <tr>
                <td style={this.tdStyleGray}>Bidding Cutoff (HH:mm)</td>
                <td style={{ ...this.tdStyle }}>
                  {rfqForm.bidding_window}
                </td>
                <td style={this.tdStyleGray}> Negotiation Cutoff (HH:mm)</td>
                <td style={{ ...this.tdStyle }}>
                  {rfqForm.negotiation_window}                </td>
                <td style={this.tdStyleGray}>Payment Terms</td>
                <td style={{ ...this.tdStyle }}>
                  As per the signed agreement
                </td>
              </tr>
              {localStorage.getItem('user_type') == 'TRANSPORTER' ? '' : <tr>
                <td style={this.tdStyleGray}>Vendor</td>
                <td colSpan="5" style={this.tdStyle}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      padding: "6px",
                      minHeight: "36px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {(rfqForm.vendors_mail ||JSON.parse(rfqForm.vendors_names) || []).map((vendor, index) => (
                      <span
                        key={index}
                        style={{
                          backgroundColor: "#d1e7dd", // light green
                          color: "#0f5132",          // dark green text
                          padding: "4px 10px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        {vendor.label ||vendor}
                      </span>
                    ))}

                    {/* Fake input for alignment (like react-select look) */}
                    <input
                      type="text"
                      disabled
                      style={{
                        border: "none",
                        outline: "none",
                        flex: "1",
                        minWidth: "60px",
                        background: "transparent",
                      }}
                    />
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </section>


        {/* Dealer & Material Info Section */}
        <section
          style={{
            backgroundColor: "#fff",
            border: "0.5px solid #FFFFF",
            borderRadius: "8px",
            marginBottom: "30px",
            overflow: "hidden",
          }}
        >
          {/* Section Header with light blue background */}
          <div
            style={{
              textAlign: "left",
              padding: "12px",
              background: "#e8f4ff",
              borderBottom: "0.5px solid #FFFFF",
              fontSize: "15px",
              fontWeight: "600",
              //   color: "#666",
            }}
          >
            Dealer & Material Information
          </div>

          {/* Table */}
          <table className="dealer-table">
            <thead>
              <tr className="dealer-table-header">
                <th rowSpan="2">Dealer Code</th>
                <th rowSpan="2">Name</th>
                <th rowSpan="2">City</th>
                <th rowSpan="2">State</th>
                <th rowSpan="2">Pincode</th>
                <th rowSpan="2">Material</th>
                <th rowSpan="2">Prerequisite</th>
                <th rowSpan="2">Qty</th>
                <th colSpan="3" className="dealer-table-dimensions-header">Dimensions (L x B x H)</th>
                {/* <th rowSpan="2">Actions</th> */}
              </tr>
              <tr className="dealer-table-header">
                <th>L</th>
                <th>B</th>
                <th>H</th>
              </tr>
            </thead>
            <tbody>
              {(dealerslist &&
                dealerslist.flatMap((dealer, index) => {
                  if (!this.isDealerRowFilled(dealer)) return [];

                  return (dealer.materials || []).map((mat, matIdx) => (
                    <tr
                      key={`${index}-${matIdx}`}
                      style={{
                        borderBottom: "1px solid #e0e0e0",
                        backgroundColor:
                          (index * (dealer.materials.length || 1) + matIdx) % 2 === 0 ? "#fff" : "#f8f9fa",
                      }}
                    >
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{dealer.dealer_code}</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{toTitleCase(dealer.dealer_name)}</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{toTitleCase(dealer.dealer_city)}</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{dealer.dealer_state}</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{dealer.dealer_pincode}</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>
                        {mat.material_type === "others" ? mat.other_material_type : mat.material_type}
                      </td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{mat.basic_requirment || ""}</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>{mat.quantity || "0"}</td>
                      <td style={{ ...this.tdStyle1, backgroundColor: "inherit" }}>
                        {`${mat.material_length || 0} ${mat.material_units}`}
                        {/* {mat.material_height && mat.material_units
                          ? `${mat.material_length} ${mat.material_units}`
                          : "-"} */}
                      </td>
                      <td style={{ ...this.tdStyle1, backgroundColor: "inherit" }}>
                         {`${mat.material_breath} ${mat.material_units}`}
                        {/* {mat.material_breath && mat.material_units
                          ? `${mat.material_breath} ${mat.material_units}`
                          : "-"} */}
                      </td>
                      <td style={{ ...this.tdStyle1, backgroundColor: "inherit" }}>
                         {`${mat.material_height} ${mat.material_units}`}
                        {/* {mat.material_length && mat.material_units
                          ? `${mat.material_height} ${mat.material_units}`
                          : "-"} */}
                      </td>

                    </tr>
                  ));
                })) || (
                  // Sample data to match the image
                  <React.Fragment>
                    <tr style={{ backgroundColor: "#fff" }}>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>75166</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>S G Associates...</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Bhilwara</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Rajasthan</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>311403</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Cabin</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}></td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>3</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>5 ft</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>12 ft</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>18 ft</td>
                    </tr>
                    <tr style={{ backgroundColor: "#f8f9fa" }}>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>75166</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>S G Associates...</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Bhilwara</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Rajasthan</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>311403</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>FSM</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}></td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>89</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>18 Cm</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>12 Cm</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>11 Cm</td>
                    </tr>
                    <tr style={{ backgroundColor: "#fff" }}>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>31197</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Tvs Vehicle Mobi...</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Madurai</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Tamilnadu</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>625016</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Box</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}></td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>3</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>5 ft</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>12 ft</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>18 ft</td>
                    </tr>
                    <tr style={{ backgroundColor: "#f8f9fa" }}>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>31197</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Tvs Vehicle Mobi...</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Madurai</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>Tamilnadu</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>625016</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>WS Glass</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}></td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>89</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>18 Cm</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>12 Cm</td>
                      <td style={{ ...this.tdStyle, backgroundColor: "inherit" }}>11 Cm</td>
                    </tr>
                  </React.Fragment>
                )}
            </tbody>
          </table>
        </section>


        {/* Additional Info Section */}
        <section
          style={{
            backgroundColor: "#fff",
            border: "0.5px solid #FFFFF",
            borderRadius: "8px",
            marginBottom: "30px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              textAlign: "left",
              padding: "12px",
              background: "#e8f4ff",
              borderBottom: "0.5px solid #FFFFF",
              fontSize: "15px",
              fontWeight: "600",
            }}
          >
            Additional Information
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <tbody>
              <tr>
                <td className="info-label">Comments</td>
                <td className="info-value" colSpan="3">{(rfqForm && rfqForm.additional_comments) || "Not Provided"}</td>
              </tr>
              <tr>
                <td className="info-label">File</td>
                <td className="info-value" colSpan="3">{(rfqForm && rfqForm.upload_for_road) || ""}</td>
              </tr>
              <tr>
                <td className="info-label">Over Breadth</td>
                <td className="info-value">{rfqForm.over_breath ? 'Yes' : 'No'}</td>
                <td className="info-label">Over Length</td>
                <td className="info-value">{rfqForm.over_length ? 'Yes' : 'No'}</td>
              </tr>
            </tbody>
          </table>
        </section>


        {this.props.checkforcreateindent ? <>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <button
              onClick={this.onBackToEdit}
              className="btn dealerbtn-cancel"
            >
              Close
            </button>
            <button
              onClick={this.onSubmitRfq}
              className='btn createindentbtn'
            >
              Submit
            </button>
          </div>

        </> : ''}

      </div>
    );
  }
}

export default RFQView;

function toTitleCase(sentence) {
  return sentence
    .toLowerCase() // make everything lowercase first
    .split(' ')    // split into words
    .filter(word => word.trim() !== '') // remove extra spaces
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}